<template>
    <div class="model-wrap mic">
        <div class="info-title">
            <span class="icon icon-info-title"></span>
            <div class="text">
                <span><tv k="m1"/></span>
                <span class="sub-text"><tv k="m2"/></span>
            </div>
            <span class="status ok"><tv k="m3"/></span>
        </div>
        <div class="model-line-bg"></div>
        <div class="model-content">
            <div class="mic-item" v-for="item in list" :key="item.name">
                <span>{{item.name}}</span>
                <el-slider v-model="item.val" class="process"></el-slider>
                <svg-icon class="mic-icon" name="mic" v-if="item.type == 1"></svg-icon>
                <svg-icon class="mic-icon" name="mic-off" v-else></svg-icon>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "PlayerModel",
        components: {
        },
        data(){
            return {
                list: [
                    {type : 0, val: 60, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                    {type : 1, val: 50, name: '手持1'},
                ]
            }
        }
    }
</script>

<style lang="less">
    .mic{
        .model-content {
            display: flex;
            flex-direction: column;
            padding: 16px;
            overflow-y: auto;

            .mic-item{
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 0;

                .mic-icon {
                    cursor: pointer;
                }

                .process{
                    padding:  0 10px;
                    flex-grow: 1;
                }
            }
        }
    }

</style>
